export default __webpack_public_path__ + "static/media/connect.f9fb192e.png";